var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7398 1.32715H5.18083C2.76617 1.32715 1.32666 2.76666 1.32666 5.18132V10.7337C1.32666 13.155 2.76617 14.5945 5.18083 14.5945H10.7332C13.1479 14.5945 14.5874 13.155 14.5874 10.7403V5.18132C14.594 2.76666 13.1545 1.32715 10.7398 1.32715ZM11.443 8.17974C11.443 8.45172 11.2175 8.67726 10.9455 8.67726C10.6735 8.67726 10.448 8.45172 10.448 8.17974V6.17637L5.32677 11.2976C5.22726 11.3971 5.10122 11.4435 4.97518 11.4435C4.84914 11.4435 4.7231 11.3971 4.6236 11.2976C4.43122 11.1052 4.43122 10.7868 4.6236 10.5944L9.7448 5.4732H7.74143C7.46945 5.4732 7.2439 5.24765 7.2439 4.97567C7.2439 4.70369 7.46945 4.47815 7.74143 4.47815H10.9455C11.2175 4.47815 11.443 4.70369 11.443 4.97567V8.17974Z",
    fill: "#9598A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowUpArrow);
export default __webpack_public_path__ + "static/media/grow-up-arrow.247f25014bff60bdf53038b4592af446.svg";
export { ForwardRef as ReactComponent };